import { render, staticRenderFns } from "./SfImage.vue?vue&type=template&id=da87b454"
import script from "./SfImage.vue?vue&type=script&lang=js"
export * from "./SfImage.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfImage.vue?vue&type=style&index=0&id=da87b454&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "c3b8984e"
  
)

export default component.exports